// import React, { useEffect, useState } from "react";
// import { Button, Modal, Radio } from "antd";
// import PropagateLoader from "react-spinners/PropagateLoader";
// import DataTable from "react-data-table-component";
// import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
// import "antd/dist/antd.css";
// import { useHistory } from "react-router-dom";
// import { getUser } from "../../Utils/Common";

// import {
//   POST_PAYOUT_GET_BENEFICIARY,
//   POST_PAYOUT_INITIATED_TRANSACTION,
//   POST_PAYOUT_V2_ADD_BENEFICIARY,
//   POST_PAYOUT_UPDATE_STATUS_BENEFICIARY,
//   POST_PAYOUT_UPDATE_BENEFICIARY_DETAIL,
//   GET_DMT_NEW_BANK_LIST,
//   GET_CUSTOMER_BANK_NAME_FROM_ACCOUNT_NUMBER,
//   IFSC_CODE_VERIFY,
//   GET_NAME,
//   RE_CHECK,
//   POST_BENE_BANK_ACCOUNT_LIMIT,
//   POST_FUND_TRANSFER_ADD_BENEFICIARY,
//   POST_FUND_TRANSFER_REQUEST,
// } from "../../Utils/appConstants";
// import { getRequest, postRequest } from "../../Utils/AppApi";
// import { ToastContainer, toast } from "react-toastify";
// import { isNumber, isAlphabetOnly } from "../../Utils/Common";
// import {
//   refId,
//   isIfscCodeValid,
//   getUTCToLocalDateFormat,
// } from "./../../Utils/function";
// import PayoutInvoice from "./../../container/payoutInvoice";
// import Select from "react-select";
// import ImportBaneficiary from "./../admin/fundTransfer/import";

// function Beneficiarylist(props) {
//   const history = useHistory();
//   const limit = 10;
//   const [getData, setData] = useState([]);
//   const [isLimit, setLimit] = useState(limit);
//   const [page, setPage] = useState(1);
//   const [saveCustomerMobile, setCustomerMobile] = useState(
//     props.customerData && props.customerData.customerMobile
//   );
//   const [saveCustomerAutoId, setCustomerAutoId] = useState(
//     props.customerData && props.customerData._id
//   );
//   const [saveCustomerName, setCustomerName] = useState(
//     props.customerData && props.customerData.customerName
//   );
//   const [isLoading, setLoading] = useState(false);
//   const [searchText, setSearchText] = useState("");
//   const [getDataField, setDataField] = useState({});
//   const [timer, setTimer] = useState(null);
//   const [latitude, setLatitude] = useState("");
//   const [longitude, setLongitude] = useState("");
//   const [bankId, setBankId] = useState(null);
//   const [bankName, setBankName] = useState("");
//   const [isAddBaneModal, setAddBaneModal] = useState(false);
//   const [isSendMoneyModal, setSendMoneyModal] = useState(false);
//   const [isSendButtonDisable, setSendButtonDisable] = useState(true);
//   const [isSelectedUser, setIsSelectedUser] = useState({});
//   const [importModal, setImportModal] = useState(false);
//   const [invoiceDataModal, setInvoiceDataModal] = useState(false);
//   const [invoiceData, setInvoiceData] = useState(null);
//   const [sendMoneyAmount, setSendMoneyAmount] = useState("");
//   const [getBeneData, setBeneData] = useState({});
//   const [getBeneError, setBeneError] = useState({});
//   const [getEKOBankListData, setEKOBankListData] = useState([]);
//   const [getBankListData, setBankListData] = useState([
//     { value: "", label: "-- Select Bank --" },
//   ]);
//   const [selectedOption, setSelectedOption] = useState(null);
//   const [isIfscEnable, setIfscEnable] = useState(false);
//   const [aadharVerifyModal, setAadharVerifyModal] = useState(false);
//   const [aadharVerifyDetail, setAadharVerifyDetail] = useState(null);
//   const [showPopup, setShowPopup] = useState(false);
//   const [beneAccountLimit, setBeneAccountLimit] = useState(25000);
//   const [selectedRelation, setSelectedRelation] = useState("");

//   const relations = [
//     "Self", "Father", "Mother", "Husband", "Wife", "Son", "Daughter",
//     "Brother", "Sister", "Grandfather", "Grandmother", "Uncle", "Aunt",
//     "Cousin Brother", "Cousin Sister", "Brother-in-law", "Sister-in-law",
//     "Father-in-law", "Mother-in-law", "Son-in-law", "Daughter-in-law",
//     "Friend", "Other",
//   ];

//   // ---- Import Beneficiary Save ----
//   const importBaneficiarySave = (data) => {
//     if (data) {
//       let payload = {
//         customerMobile: saveCustomerMobile,
//         beneficiaryMobileNumber: data.recipientMobile,
//         accountNumber: data.accountNumber,
//         ifscCode: data.ifscCode,
//         bankId: data.bankId,
//         bankName: data.bankName,
//         recipientName: data.recipientName,
//         beneBankName: data.beneBankName,
//         latitude: latitude,
//         longitude: longitude,
//         devicetype: "W",
//       };
//       setLoading(true);
//       postRequest(`${POST_FUND_TRANSFER_ADD_BENEFICIARY}`, payload, history)
//         .then((response) => {
//           if (response.success === true) {
//             setImportModal(false);
//             getDataReports();
//             toast.success(response.message);
//           } else {
//             toast.error(response.message);
//           }
//           setLoading(false);
//         })
//         .catch(function (error) {
//           console.log(error);
//           setLoading(false);
//           toast.error("Error adding beneficiary");
//         });
//     }
//   };

//   // ---- Columns ----
//   const columns = [
//     {
//       name: "Nick Name",
//       selector: (row) => (
//         <>
//           <div>{row.beneName}</div>
//           {row.beneMobile && (
//             <div><strong>Mobile</strong>: {row.beneMobile}</div>
//           )}
//         </>
//       ),
//       width: "200px",
//     },
//     {
//       name: "IFSC / Bank",
//       selector: (row) => (
//         <>
//           <div><strong>IFSC</strong>: {row.ifscCode}</div>
//           {row.bankName && (
//             <div><strong>Bank</strong>: {row.bankName}</div>
//           )}
//         </>
//       ),
//       width: "200px",
//     },
//     {
//       name: "Account",
//       selector: (row) => (
//         <>
//           <div>{row.accountNumber}</div>
//           <div><strong>UP</strong>: {getUTCToLocalDateFormat(row.updatedAt)}</div>
//         </>
//       ),
//       width: "150px",
//     },
//     {
//       name: "Bene Name",
//       selector: (row) => (
//         <div>
//           <strong>
//             {row.isVerified ? (
//               <CheckOutlined className="text-120 text-success border p-1" />
//             ) : (
//               <CloseOutlined className="text-120 text-danger border p-1" />
//             )}
//           </strong>{" "}
//           {row.beneBankName}{" "}
//         </div>
//       ),
//       width: "200px",
//     },
//     {
//       name: "Verified",
//       selector: (row) => (
//         <>
//           {row.isVerified ? (
//             <button
//               onClick={() => getName(row, true)}
//               className={`pointer text-success`}
//               disabled={!row.isActive}
//             >
//               {RE_CHECK}
//             </button>
//           ) : (
//             <button
//               onClick={() => getName(row, false)}
//               className={`pointer text-danger`}
//               disabled={!row.isActive}
//             >
//               {GET_NAME}
//             </button>
//           )}
//         </>
//       ),
//       width: "150px",
//     },
//     {
//       name: "Status",
//       selector: (row) =>
//         !row.beneficiary_id || row.beneficiary_id.trim() === "" ? (
//           <button
//             className="pointer text-danger"
//             disabled
//             style={{
//               whiteSpace: "normal",
//               wordWrap: "break-word",
//               maxWidth: "100px",
//             }}
//           >
//             Bene ID Missing
//           </button>
//         ) : row.isActive ? (
//           <button
//             onClick={() => beneStatus(row, false)}
//             className="pointer text-success"
//           >
//             Active
//           </button>
//         ) : (
//           <button
//             onClick={() => beneStatus(row, true)}
//             className="pointer text-danger"
//           >
//             Deactive
//           </button>
//         ),
//       width: "100px",
//     },
//     {
//       name: "Amount",
//       // ⚠️ react-data-table-component passes (row, index) only when you
//       //     use `cell`, not `selector`. Using `cell` fixes the index.
//       cell: (row, index) => (
//         <input
//           type="text"
//           name="amount"
//           className="form-control"
//           onChange={(e) => handleEditRowAmount(e, index)}
//           placeholder="Amount"
//           onKeyDown={isNumber}
//           maxLength={5}
//           disabled={!row.isActive}
//         />
//       ),
//       width: "120px",
//     },
//     {
//       name: "Action",
//       selector: (row) => (
//         <Button
//           type="primary"
//           onClick={() => sendMoney(row)}
//           disabled={row.isActive ? isSendButtonDisable : true}
//           size="small"           // ✅ was `small` (invalid DOM prop)
//         >
//           Send
//         </Button>
//       ),
//       width: "150px",
//       fixed: "right",
//     },
//   ];

//   useEffect(() => {
//     setCustomerMobile(props.customerData && props.customerData.customerMobile);
//     setCustomerAutoId(props.customerData && props.customerData._id);
//     setCustomerName(props.customerData && props.customerData.customerName);
//   }, [props.customerData]);

//   const handleSyncBeneficiary = () => {
//     getDataReports();
//   };

//   const beneStatus = (data, status) => {
//     let params = {};
//     params.id = data._id;
//     params.status = status;
//     postRequest(POST_PAYOUT_UPDATE_STATUS_BENEFICIARY, params, history)
//       .then((response) => {
//         if (response.success === true) {
//           getDataReports();
//         }
//         toast.success(response.message, { toastId: "success1" });
//       })
//       .catch(function (error) { });
//   };

//   const beneBankLimit = (account_Number, detailFor) => {
//     let params = {};
//     params.accountNumber = account_Number;
//     params.detail_for = detailFor;
//     postRequest(POST_BENE_BANK_ACCOUNT_LIMIT, params, history)
//       .then((response) => {
//         if (response.success === true) {
//           setBeneAccountLimit(response.beneAccountLimit);
//         }
//       })
//       .catch(function (error) { });
//   };

//   const updateBeneData = (data) => {
//     let params = {};
//     params.id = data._id;
//     params.beneBankName = data.beneBankName;
//     postRequest(POST_PAYOUT_UPDATE_BENEFICIARY_DETAIL, params, history)
//       .then((response) => {
//         if (response.success === true) {
//           getDataReports();
//         }
//       })
//       .catch(function (error) { });
//   };

//   const getBankList = () => {
//     getRequest(GET_DMT_NEW_BANK_LIST, history)
//       .then((response) => {
//         if (response.success === true) {
//           let bankDataRecord = [];
//           if (response.data) {
//             bankDataRecord = response.data.filter(
//               (item) => item.key === "DMT1.0"
//             );
//           }
//           setEKOBankListData(bankDataRecord);
//           setBankListData([
//             { value: "", label: "-- Select Bank --" },
//             ...bankDataRecord.map((item) => ({
//               value: item.BankID,
//               label: item.BANK_NAME,
//             })),
//           ]);
//         }
//       })
//       .catch(function (error) { });
//   };

//   const onChangeBankIfscCode = (value) => {
//     if (value) {
//       let findBank = getEKOBankListData.filter((item) => item.BankID === value);
//       if (findBank.length > 0) {
//         setSelectedOption({
//           value: findBank[0].BankID,
//           label: findBank[0].BANK_NAME,
//         });
//         if (findBank[0].ifsc) {
//           setBeneData({ ...getBeneData, ifscCode: findBank[0].ifsc });
//           let obj = {};
//           obj.target = { name: "ifscCode", value: findBank[0].ifsc };
//           enterIfscCode(obj);
//           setIfscEnable(true);
//         } else {
//           setBeneData({ ...getBeneData, ifscCode: "" });
//           setIfscEnable(false);
//         }
//         setBankId(findBank[0].BankID);
//         setBankName(findBank[0].BANK_NAME);
//       } else {
//         setBankId(null);
//       }
//     } else {
//       setBankId(null);
//       setIfscEnable(false);
//       setBeneData({ ...getBeneData, ifscCode: "" });
//     }
//   };

//   const enterIfscCode = async (event) => {
//     let { name, value } = event.target;
//     setBeneData({ ...getBeneData, [name]: value });
//     if (isIfscCodeValid(value)) {
//       onChangeIfscCode(value);
//       setBeneError({ ...getBeneError, ifscCodeVaild: 1 });
//     } else {
//       setBeneError({ ...getBeneError, ifscCodeVaild: 2 });
//     }
//   };

//   const handleEditRowAmount = (event, index) => {
//     let array = { ...getData };
//     array.docs[index].amount = event.target.value;
//     const value = parseFloat(event.target.value);
//     const maxLimit = Math.min(
//       props.customerData?.availableLimit || 10000,
//       props.eligibleLimit || 10000
//     );
//     if (value < 500) {
//       toast.error("Minimum amount is: 500", { toastId: "error_min" });
//       setSendButtonDisable(true);
//       event.preventDefault();
//       return false;
//     } else if (value > maxLimit) {
//       toast.error(`Maximum amount is: ${maxLimit}`, { toastId: "error_max" });
//       setSendButtonDisable(true);
//       event.preventDefault();
//       return false;
//     } else {
//       setSendButtonDisable(value < 1);
//       setData(array);
//     }
//   };

//   const handleAmount = (event) => {
//     const value = parseFloat(event.target.value);
//     const maxLimit = Math.min(
//       props.customerData?.availableLimit || 10000,
//       props.eligibleLimit || 10000
//     );
//     if (value > maxLimit) {
//       toast.error(`Amount cannot exceed eligible limit of ${maxLimit}`);
//       event.preventDefault();
//       return;
//     }
//     setSendMoneyAmount(event.target.value);
//   };

//   const onChangeAddBeneName = async (event) => {
//     let { name, value } = event.target;
//     if (isAlphabetOnly(value)) {
//       setBeneData({ ...getBeneData, [name]: value });
//     } else {
//       event.preventDefault();
//     }
//   };

//   const onChangeAddBene = (event) => {
//     let { name, value } = event.target;
//     setBeneData({ ...getBeneData, [name]: value });
//   };

//   const sendMoney = (row) => {
//     if (!row.beneficiary_id?.trim()) {
//       toast.error(
//         "Beneficiary ID is missing. Please contact SR PAY Support Team"
//       );
//       return false;
//     }
//     if (!row.amount) {
//       toast.error("Amount is empty");
//       return false;
//     }
//     if (!row.isVerified || !row.beneBankName || row.beneBankName.trim() === "") {
//       toast.error(
//         "Beneficiary bank account is not verified. Please verify first."
//       );
//       return false;
//     }
//     setSendMoneyModal(true);
//     row.isChannel = isSelectedUser.isChannel ? isSelectedUser.isChannel : "4";
//     setIsSelectedUser(row);
//     beneBankLimit(row.accountNumber, "quickSettlement");
//   };

//   const handleSave = (data) => {
//     if (sendMoneyAmount !== data.amount) {
//       toast.error("Amount did not matched.");
//     } else {
//       const payload = {
//         customerId: saveCustomerAutoId,
//         customerName: saveCustomerName,
//         beneficiaryId: data._id,
//         beneficiaryName: data.beneName,
//         accountNumber: data.accountNumber,
//         ifsccode: data.ifscCode,
//         amount: sendMoneyAmount,
//         channel: data.isChannel,
//         apiName: "PAYOUTV2",
//         latitude: latitude,
//         longitude: longitude,
//         detail_for: "quickSettlement",
//         txnType: "fund_transfer",
//       };
//       handleSubmit(payload);
//     }
//   };

//   const handleSubmit = async (data) => {
//     setLoading(true);
//     await postRequest(`${POST_FUND_TRANSFER_REQUEST}`, data, history)
//       .then((response) => {
//         if (response.success === true) {
//           handleHideModal();
//           getDataReports();
//           toast.success(response.message);
//           const txnId = response.data?.transactionId;
//           if (txnId) {
//             history.push(`/fundtransferinvoice/${txnId}`);
//           } else {
//             history.push("/fund-transfer-report");
//           }
//         } else {
//           toast.error(response.message);
//         }
//         setSendMoneyAmount("");
//         setLoading(false);
//       })
//       .catch(function (error) {
//         console.log(error);
//         setLoading(false);
//         handleHideModal();
//         toast.error("Transaction failed");
//       });
//   };

//   const handleInvoice = (data) => {
//     setInvoiceDataModal(true);
//     setInvoiceData(data);
//   };

//   const handleInvoiceModal = () => {
//     setInvoiceDataModal(false);
//   };

//   const addBane = () => {
//     // reset state BEFORE opening so inputs mount with empty strings, not undefined
//     setBeneData({
//       mobile: "",
//       name: "",
//       ifscCode: "",
//       accountNumber: "",
//       beneBankName: "",
//     });
//     setDataField({});
//     setSelectedOption(null);
//     setIfscEnable(false);
//     setBankId(null);
//     setBankName("");
//     setBeneError({});
//     setAddBaneModal(true);
//   };

//   const FormBaneValidate = () => {
//     let formValid = true;
//     let formObject = {};
//     setBeneError({});
//     let array = ["mobile", "name", "ifscCode", "accountNumber"];
//     array.forEach((element) => {
//       if (!getBeneData[element] || getBeneData[element] === "") {
//         formObject[element] = true;
//         formValid = false;
//       }
//     });
//     if (!getBeneData.beneBankName || getBeneData.beneBankName.trim() === "") {
//       formObject.beneBankName = true;
//       formValid = false;
//     }
//     setBeneError(formObject);
//     return formValid;
//   };

//   const addBaneSave = () => {
//     if (FormBaneValidate() === true) {
//       const payload = {
//         customerMobile: saveCustomerMobile,
//         recipientMobile: getBeneData.mobile,
//         accountNumber: getBeneData.accountNumber,
//         ifscCode: getBeneData.ifscCode,
//         bankId: bankId,
//         bankName: bankName,
//         recipientName: getBeneData.name,
//         beneBankName: getBeneData.beneBankName,
//         apiName: "PAYOUTV2",
//         latitude: latitude,
//         longitude: longitude,
//         isRemittanceBene: false,
//       };
//       setLoading(true);
//       postRequest(`${POST_FUND_TRANSFER_ADD_BENEFICIARY}`, payload, history)
//         .then((response) => {
//           if (response.success === true) {
//             toast.success(response.message);
//             getDataReports();
//             setBeneData({});
//             setAddBaneModal(false);
//           } else {
//             toast.error(response.message);
//           }
//           setLoading(false);
//         })
//         .catch(function (error) {
//           setLoading(false);
//         });
//     }
//   };

//   const handleHideModal = () => {
//     setSendMoneyModal(false);
//     setAddBaneModal(false);
//   };

//   const objectToQueryString = (obj) => {
//     var str = [];
//     for (var p in obj)
//       if (obj.hasOwnProperty(p)) {
//         str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
//       }
//     return str.join("&");
//   };

//   const params = { page: page, limit: isLimit };

//   const getDataReports = (data) => {
//     if (data) {
//       setLimit(data);
//       params.limit = data;
//     }
//     if (searchText) {
//       params.search = searchText;
//     }
//     if (props.customerData && props.customerData.customerMobile) {
//       params.customerMobile = props.customerData.customerMobile;
//       setCustomerMobile(params.customerMobile);
//     }
//     const queryString = objectToQueryString(params);
//     getRequest(`${POST_PAYOUT_GET_BENEFICIARY}?${queryString}`, history)
//       .then((response) => {
//         if (response.success === true) {
//           setData(response.data);
//         } else {
//           setPage(1);
//         }
//       })
//       .catch(function (error) { });
//   };

//   const handlePageChange = (page) => {
//     setPage(page);
//   };

//   const getName = (data, recheck) => {
//     if (data.accountNumber && data.ifscCode) {
//       setLoading(true);
//       const payload = {
//         ifsccode: data.ifscCode,
//         accountNumber: data.accountNumber,
//         externalRef: refId(13),
//         consent: "Y",
//         pennyDrop: "AUTO",
//         recheck: recheck,
//         latitude: latitude,
//         longitude: longitude,
//       };
//       postRequest(
//         `${GET_CUSTOMER_BANK_NAME_FROM_ACCOUNT_NUMBER}`,
//         payload,
//         history
//       )
//         .then((response) => {
//           if (response.success === true) {
//             let record = response.data.data;
//             setAadharVerifyModal(true);
//             setAadharVerifyDetail(response.data);
//             data.beneBankName = record.nameAtBank;
//             updateBeneData(data);
//           } else {
//             toast.error(response.message);
//           }
//           setLoading(false);
//         })
//         .catch(function (error) {
//           setLoading(false);
//         });
//     }
//   };

//   const getBankNameFromAccountNumber = () => {
//     if (getBeneData.accountNumber && getBeneData.ifscCode) {
//       setLoading(true);
//       const payload = {
//         ifsccode: getBeneData.ifscCode,
//         accountNumber: getBeneData.accountNumber,
//         externalRef: refId(13),
//         consent: "Y",
//         pennyDrop: "AUTO",
//         latitude: latitude,
//         longitude: longitude,
//       };
//       postRequest(
//         `${GET_CUSTOMER_BANK_NAME_FROM_ACCOUNT_NUMBER}`,
//         payload,
//         history
//       )
//         .then((response) => {
//           if (response.success === true) {
//             let record = response.data.data;
//             let Object = { beneBankName: record.nameAtBank };
//             setBeneData({ ...getBeneData, ...Object });
//           } else {
//             toast.error(response.message);
//           }
//           setLoading(false);
//         })
//         .catch(function (error) {
//           setLoading(false);
//         });
//     } else {
//       toast.error("Please enter valid account number");
//       setBeneData({ ...getBeneData, name: "" });
//     }
//   };

//   const onChangeIfscCode = (val = null) => {
//     let value;
//     if (val) {
//       value = val;
//     } else {
//       value = getBeneData && getBeneData.ifscCode;
//     }
//     if (isIfscCodeValid(value)) {
//       const payload = { ifsccode: value };
//       postRequest(`${IFSC_CODE_VERIFY}`, payload, history)
//         .then((response) => {
//           if (response.success === true) {
//             let record = response.data.data;
//             let Object = {
//               ifscCode: record.ifsc,
//               address: record.address,
//               bankName: record.bank,
//               branchAddress: record.branch,
//               city: record.city,
//               state: record.state,
//             };
//             setDataField(Object);
//           }
//         })
//         .catch(function (error) { });
//     } else {
//       if (value && value.length === 11) {
//         toast.error("Please enter valid ifsccode");
//         setDataField({
//           address: "",
//           bankName: "",
//           branchAddress: "",
//           city: "",
//           state: "",
//         });
//       }
//     }
//   };

//   const handleSearch = (e) => {
//     setSearchText(e.target.value);
//   };

//   const onChangeChannel = ({ target: { value } }) => {
//     let isSelectedUserValue = { ...isSelectedUser };
//     isSelectedUserValue.isChannel = value;
//     setIsSelectedUser(isSelectedUserValue);
//   };

//   const handleImport = () => {
//     setImportModal(true);
//   };

//   const handleImportCancel = () => {
//     setImportModal(false);
//   };

//   useEffect(() => {
//     if (timer) {
//       clearTimeout(timer);
//       setTimer(null);
//     }
//     setTimer(
//       setTimeout(() => {
//         getDataReports();
//       }, 100)
//     );
//   }, [searchText]);

//   useEffect(() => {
//     if (props.customerData && props.customerData.customerMobile) {
//       getDataReports();
//     }
//   }, [page, props.handleSearch]);

//   useEffect(() => {
//     getBankList();
//     const userData = getUser();
//     const shopsLat = userData?.data?.shopsLat;
//     const shopsLong = userData?.data?.shopsLong;
//     if (shopsLat !== undefined && shopsLat !== null && Number(shopsLat) !== 0) {
//       setLatitude(Number(shopsLat));
//       setLongitude(Number(shopsLong));
//     } else {
//       navigator.geolocation.getCurrentPosition((data) => {
//         setLatitude(data.coords.latitude);
//         setLongitude(data.coords.longitude);
//       });
//     }
//   }, [props.customerData]);

//   if (isLoading) {
//     return (
//       <div className="content text-center" style={{ margin: "250px 0" }}>
//         <PropagateLoader color="#5851D2" loading={isLoading} size={25} />
//       </div>
//     );
//   }

//   return (
//     <div>
//       <div className="pt-2 pb-5">
//         <div className="col-md-12">
//           <div className="row pb-3">
//             <div className="col-md-6 date-search">
//               <div className="row">
//                 <div className="input-group">
//                   <input
//                     className="form-control py-2 border-right-0 border"
//                     type="search"
//                     value={searchText}
//                     placeholder="Search Account Number..."
//                     maxLength={20}
//                     onChange={(e) => handleSearch(e)}
//                   />
//                   <span className="input-group-append">
//                     <button
//                       className="btn btn-outline-secondary border-left-0 border"
//                       type="button"
//                       onClick={() => getDataReports()}
//                     >
//                       <i className="fa fa-search" />
//                     </button>
//                   </span>
//                 </div>
//               </div>
//             </div>
//             <div className="col-md-6 p-0">
//               <div className="float-sm-right">
//                 <button
//                   type="button"
//                   className="btn btn-primary mr-2"
//                   onClick={() => handleImport()}
//                 >
//                   <i className="fa fa-users"></i> Import
//                 </button>
//                 <button
//                   type="button"
//                   className="btn btn-primary mr-2"
//                   onClick={() => handleSyncBeneficiary()}
//                 >
//                   <i className="fa fa-users"></i> View Beneficiary
//                 </button>
//                 <button
//                   type="button"
//                   className="btn btn-primary"
//                   onClick={addBane}
//                 >
//                   <i className="fa fa-user"></i> Add Beneficiary
//                 </button>
//               </div>
//             </div>
//           </div>

//           <div className="box-body">
//             <DataTable
//               columns={columns}
//               data={getData.docs || []}
//               highlightOnHover
//               pagination
//               paginationServer
//               paginationTotalRows={getData.totalDocs || 0}
//               onChangeRowsPerPage={getDataReports}
//               onChangePage={handlePageChange}
//             />
//           </div>
//         </div>
//       </div>

//       <ToastContainer
//         position="top-center"
//         autoClose={5000}
//         limit={2}
//         hideProgressBar={false}
//         newestOnTop={false}
//         closeOnClick
//         rtl={false}
//         pauseOnFocusLoss
//         draggable
//         pauseOnHover
//         theme="colored"
//       />

//       {/* ============================================================
//           Add Beneficiary Modal
//           ⚠️ antd v4 uses `visible`. We conditionally render AND pass
//           `visible` so it works regardless of v4/v5 quirks.
//           ============================================================ */}
//       {isAddBaneModal && (
//         <Modal
//           title={"Add Beneficiary"}
//           width={400}
//           visible={isAddBaneModal}
//           onOk={addBaneSave}
//           onCancel={handleHideModal}
//           okText={"Submit"}
//           cancelText={"Cancel"}
//           destroyOnClose
//         >
//           <div className="row">
//             <div className="form-group col-lg-12 col-md-12">
//               <label>Account Holder Mobile</label>
//               <div className="input-group">
//                 <div className="custom-file">
//                   <input
//                     type="text"
//                     className="form-control"
//                     name="mobile"
//                     placeholder="Mobile Number"
//                     onChange={(e) => onChangeAddBene(e)}
//                     autoComplete="off"
//                     value={getBeneData.mobile || ""}
//                     maxLength={10}
//                     onKeyDown={isNumber}
//                   />
//                 </div>
//               </div>
//               {getBeneError && getBeneError.mobile && (
//                 <span className="error text-danger">The field is required</span>
//               )}
//             </div>

//             <div className="form-group col-lg-12 col-md-12">
//               <label>Account Holder Name</label>
//               <div className="input-group">
//                 <div className="custom-file">
//                   <input
//                     type="text"
//                     className="form-control"
//                     name="name"
//                     placeholder="Account Holder Name"
//                     onChange={(e) => onChangeAddBeneName(e)}
//                     autoComplete="off"
//                     value={getBeneData.name || ""}
//                     maxLength={20}
//                   />
//                 </div>
//               </div>
//               {getBeneError && getBeneError.name && (
//                 <span className="error text-danger">The field is required</span>
//               )}
//             </div>

//             <div className="form-group col-lg-12 col-md-12">
//               <label>Bank Name</label>
//               <div className="input-group">
//                 <div className="custom-file">
//                   <Select
//                     options={getBankListData}
//                     className={`normal-light w-100`}
//                     value={selectedOption}
//                     classNamePrefix="select"
//                     placeholder="Select Bank"
//                     name="mode"
//                     isClearable
//                     onChange={(e) => onChangeBankIfscCode(e && e.value)}
//                   />
//                 </div>
//               </div>
//             </div>

//             <div className="form-group col-lg-12 col-md-12">
//               <label>Global IFSC Code</label>
//               <div className="input-group">
//                 <div className="custom-file">
//                   <input
//                     type="text"
//                     className="form-control"
//                     name="ifscCode"
//                     placeholder="Enter IFSC Code"
//                     onChange={(e) => enterIfscCode(e)}
//                     autoComplete="off"
//                     readOnly={isIfscEnable}
//                     value={getBeneData.ifscCode || ""}
//                     maxLength={11}
//                   />
//                   <div
//                     className="inputgrouptext cursor-pointer text-success"
//                     onClick={() =>
//                       onChangeIfscCode(getBeneData && getBeneData.ifscCode)
//                     }
//                   >
//                     Verify Branch
//                   </div>
//                 </div>
//               </div>
//               {getBeneError && getBeneError.ifscCode && (
//                 <span className="error text-danger">The field is required</span>
//               )}
//             </div>

//             {getDataField &&
//               getDataField.address &&
//               getDataField.bankName &&
//               getDataField.branchAddress &&
//               getDataField.city &&
//               getDataField.state && (
//                 <div className="form-group col-lg-12 col-md-12">
//                   <div className="custom-file">
//                     <ul>
//                       <li>Address: <strong>{getDataField.address}</strong></li>
//                       <li>Bank Name: <strong>{getDataField.bankName}</strong></li>
//                       <li>Branch Address: <strong>{getDataField.branchAddress}</strong></li>
//                       <li>City: <strong>{getDataField.city}</strong></li>
//                       <li>State: <strong>{getDataField.state}</strong></li>
//                     </ul>
//                   </div>
//                 </div>
//               )}

//             <div className="form-group col-lg-12 col-md-12">
//               <label>Account Number</label>
//               <div className="input-group">
//                 <div className="custom-file">
//                   <input
//                     type="text"
//                     className="form-control"
//                     name="accountNumber"
//                     placeholder="Account Number"
//                     onChange={(e) => onChangeAddBene(e)}
//                     autoComplete="off"
//                     value={getBeneData.accountNumber || ""}
//                     maxLength={18}
//                   />
//                   <button
//                     className={`inputgrouptext cursor-pointer text-success`}
//                     onClick={getBankNameFromAccountNumber}
//                   >
//                     {GET_NAME}
//                   </button>
//                 </div>
//               </div>
//               {getBeneError && getBeneError.accountNumber && (
//                 <span className="error text-danger">The field is required</span>
//               )}
//             </div>

//             {getBeneData.beneBankName && (
//               <div className="form-group col-lg-12 col-md-12">
//                 <label>Bene Bank Name</label>
//                 <div className="input-group">
//                   <div className="custom-file">
//                     <input
//                       type="text"
//                       className="form-control"
//                       readOnly
//                       autoComplete="off"
//                       value={getBeneData.beneBankName || ""}
//                       maxLength={20}
//                     />
//                   </div>
//                 </div>
//               </div>
//             )}
//           </div>
//         </Modal>
//       )}

//       {/* Send Money Modal */}
//       {isSendMoneyModal && (
//         <Modal
//           title={"Money Transfer Verification"}
//           width={600}
//           visible={isSendMoneyModal}
//           onOk={() => handleSave(isSelectedUser)}
//           onCancel={handleHideModal}
//           okText={"Continue"}
//           cancelText={"Cancel"}
//         >
//           <div className="row">
//             <div className="col-md-12 form-group d-flex">
//               <div className="col-md-8">
//                 <div>Bank Name : <strong>{isSelectedUser.bankName}</strong></div>
//                 <div>IFSC Code : <strong>{isSelectedUser.ifscCode}</strong></div>
//                 <div>Account Number : <strong>{isSelectedUser.accountNumber}</strong></div>
//                 <div>Customer Name : <strong>{isSelectedUser.beneName}</strong></div>
//                 <div>Account Limit : <strong>{beneAccountLimit}</strong></div>
//                 <div>
//                   Customer Available Limit :{" "}
//                   <strong>{props.customerData?.availableLimit || "N/A"}</strong>
//                 </div>
//               </div>
//             </div>

//             <div className="col-md-12 form-group">
//               <label htmlFor="relation">Select Relation:</label>
//               <br />
//               <select
//                 id="relation"
//                 value={selectedRelation}
//                 onChange={(e) => setSelectedRelation(e.target.value)}
//                 style={{ padding: "8px", marginTop: "5px", width: "250px" }}
//               >
//                 <option value="">Friend</option>
//                 {relations.map((relation, index) => (
//                   <option key={index} value={relation}>{relation}</option>
//                 ))}
//               </select>
//               {selectedRelation && (
//                 <p style={{ marginTop: "10px" }}>
//                   You selected: <strong>{selectedRelation}</strong>
//                 </p>
//               )}
//             </div>

//             <div className="col-md-12 form-group">
//               <label>
//                 <span style={{ color: "#D97706", fontWeight: "bold" }}>
//                   Please Note:
//                 </span>{" "}
//                 Your fund settlement request will take up to 30 minutes to process. Please check your transaction status after some time.
//                 <span style={{ fontWeight: "bold" }}>
//                   Please confirm to continue.
//                 </span>
//               </label>
//               {/* <label>Mode:</label> */}
//               {/* <br />
//               <Radio.Group
//                 defaultValue={4}
//                 buttonStyle="solid"
//                 onChange={onChangeChannel}
//                 optionType="button"
//               >
//                 <Radio.Button value={4}>NEFT</Radio.Button>
//                 <Radio.Button value={5}>IMPS</Radio.Button>
//               </Radio.Group> */}
//             </div>




//             <div className="col-md-12 form-group">
//               <label>Confirm Amount: </label>
//               <input
//                 type="text"
//                 name="amount"
//                 className="form-group form-control"
//                 value={sendMoneyAmount || ""}
//                 onChange={(e) => handleAmount(e)}
//                 onKeyDown={isNumber}
//                 maxLength={5}
//                 placeholder="Confirm Amount"
//               />
//             </div>
//           </div>
//         </Modal>
//       )}

//       {/* Invoice Modal */}
//       {invoiceDataModal && (
//         <Modal
//           visible={invoiceDataModal}
//           width={800}
//           footer={false}
//           onCancel={handleInvoiceModal}
//           closable={false}
//         >
//           <PayoutInvoice
//             transactionId={invoiceData && invoiceData.transactionId}
//           />
//         </Modal>
//       )}

//       {/* Aadhaar Verify Modal */}
//       {aadharVerifyModal && (
//         <Modal
//           title={"Aadhaar Verification Detail"}
//           width={600}
//           visible={aadharVerifyModal}
//           onOk={() => {
//             setAadharVerifyDetail({});
//             setAadharVerifyModal(false);
//           }}
//           onCancel={() => {
//             setAadharVerifyDetail({});
//             setAadharVerifyModal(false);
//           }}
//           okText={"Ok"}
//           cancelText={"Cancel"}
//         >
//           <div className="row">
//             <div className="col-md-12 form-group">
//               <div>
//                 Name :{" "}
//                 <strong>
//                   {aadharVerifyDetail && aadharVerifyDetail.data?.nameAtBank}
//                 </strong>
//               </div>
//               <div>
//                 {aadharVerifyDetail &&
//                   aadharVerifyDetail.accountStatus === "VALID" ? (
//                   <p className="text-bold text-success">
//                     {aadharVerifyDetail && aadharVerifyDetail.message}
//                   </p>
//                 ) : (
//                   <p className="text-bold text-danger">
//                     {aadharVerifyDetail && aadharVerifyDetail.message}
//                   </p>
//                 )}
//               </div>
//             </div>
//           </div>
//         </Modal>
//       )}

//       {/* Import Modal */}
//       {importModal && (
//         <Modal
//           visible={importModal}
//           width={1200}
//           footer={false}
//           onCancel={handleImportCancel}
//           closable={true}
//           maskClosable={false}
//           keyboard={false}
//           destroyOnClose={true}
//         >
//           <ImportBaneficiary
//             mode={"DMT1.0"}
//             customerMobile={saveCustomerMobile}
//             addBaneficiary={importBaneficiarySave}
//             bankList={getBankListData}
//             bankData={getEKOBankListData}
//           />
//         </Modal>
//       )}
//     </div>
//   );
// }

// export default Beneficiarylist;

import React, { useEffect, useState } from "react";
import { Button, Modal, Radio } from "antd";
import PropagateLoader from "react-spinners/PropagateLoader";
import DataTable from "react-data-table-component";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import "antd/dist/antd.css";
import { useHistory } from "react-router-dom";
import { getUser } from "../../Utils/Common";

import {
  POST_PAYOUT_GET_BENEFICIARY,
  POST_PAYOUT_INITIATED_TRANSACTION,
  POST_PAYOUT_V2_ADD_BENEFICIARY,
  POST_PAYOUT_UPDATE_STATUS_BENEFICIARY,
  POST_PAYOUT_UPDATE_BENEFICIARY_DETAIL,
  GET_DMT_NEW_BANK_LIST,
  GET_CUSTOMER_BANK_NAME_FROM_ACCOUNT_NUMBER,
  IFSC_CODE_VERIFY,
  GET_NAME,
  RE_CHECK,
  POST_BENE_BANK_ACCOUNT_LIMIT,
  POST_FUND_TRANSFER_ADD_BENEFICIARY,
  POST_FUND_TRANSFER_REQUEST,
} from "../../Utils/appConstants";
import { getRequest, postRequest } from "../../Utils/AppApi";
import { ToastContainer, toast } from "react-toastify";
import { isNumber, isAlphabetOnly } from "../../Utils/Common";
import {
  refId,
  isIfscCodeValid,
  getUTCToLocalDateFormat,
} from "./../../Utils/function";
import PayoutInvoice from "./../../container/payoutInvoice";
import Select from "react-select";
import ImportBaneficiary from "./../admin/fundTransfer/import";

// ---- Shared bank verification (single-file module) ----
import {
  showBankVerifyPicker,
  useBankVerification,
} from "../../Utils/bankVerification";

function Beneficiarylist(props) {
  const history = useHistory();
  const limit = 10;
  const [getData, setData] = useState([]);
  const [isLimit, setLimit] = useState(limit);
  const [page, setPage] = useState(1);
  const [saveCustomerMobile, setCustomerMobile] = useState(
    props.customerData && props.customerData.customerMobile
  );
  const [saveCustomerAutoId, setCustomerAutoId] = useState(
    props.customerData && props.customerData._id
  );
  const [saveCustomerName, setCustomerName] = useState(
    props.customerData && props.customerData.customerName
  );
  const [isLoading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [getDataField, setDataField] = useState({});
  const [timer, setTimer] = useState(null);
  const [latitude, setLatitude] = useState("");
  const [longitude, setLongitude] = useState("");
  const [bankId, setBankId] = useState(null);
  const [bankName, setBankName] = useState("");
  const [isAddBaneModal, setAddBaneModal] = useState(false);
  const [isSendMoneyModal, setSendMoneyModal] = useState(false);
  const [isSendButtonDisable, setSendButtonDisable] = useState(true);
  const [isSelectedUser, setIsSelectedUser] = useState({});
  const [importModal, setImportModal] = useState(false);
  const [invoiceDataModal, setInvoiceDataModal] = useState(false);
  const [invoiceData, setInvoiceData] = useState(null);
  const [sendMoneyAmount, setSendMoneyAmount] = useState("");
  const [getBeneData, setBeneData] = useState({});
  const [getBeneError, setBeneError] = useState({});
  const [getEKOBankListData, setEKOBankListData] = useState([]);
  const [getBankListData, setBankListData] = useState([
    { value: "", label: "-- Select Bank --" },
  ]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [isIfscEnable, setIfscEnable] = useState(false);
  const [aadharVerifyModal, setAadharVerifyModal] = useState(false);
  const [aadharVerifyDetail, setAadharVerifyDetail] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [beneAccountLimit, setBeneAccountLimit] = useState(25000);
  const [selectedRelation, setSelectedRelation] = useState("Friend");

  // ---- Bank verification (shared hook) ----
  const { verifyingKey, verify } = useBankVerification();

  const relations = [
    "Self", "Father", "Mother", "Husband", "Wife", "Son", "Daughter",
    "Brother", "Sister", "Grandfather", "Grandmother", "Uncle", "Aunt",
    "Cousin Brother", "Cousin Sister", "Brother-in-law", "Sister-in-law",
    "Father-in-law", "Mother-in-law", "Son-in-law", "Daughter-in-law",
    "Friend", "Other",
  ];

  // ---- Import Beneficiary Save ----
  const importBaneficiarySave = (data) => {
    if (data) {
      let payload = {
        customerMobile: saveCustomerMobile,
        beneficiaryMobileNumber: data.recipientMobile,
        accountNumber: data.accountNumber,
        ifscCode: data.ifscCode,
        bankId: data.bankId,
        bankName: data.bankName,
        recipientName: data.recipientName,
        beneBankName: data.beneBankName,
        latitude: latitude,
        longitude: longitude,
        devicetype: "W",
      };
      setLoading(true);
      postRequest(`${POST_FUND_TRANSFER_ADD_BENEFICIARY}`, payload, history)
        .then((response) => {
          if (response.success === true) {
            setImportModal(false);
            getDataReports();
            toast.success(response.message);
          } else {
            toast.error(response.message);
          }
          setLoading(false);
        })
        .catch(function (error) {
          console.log(error);
          setLoading(false);
          toast.error("Error adding beneficiary");
        });
    }
  };

  // ---- Columns ----
  const columns = [
    {
      name: "Nick Name",
      selector: (row) => (
        <>
          <div>{row.beneName}</div>
          {row.beneMobile && (
            <div><strong>Mobile</strong>: {row.beneMobile}</div>
          )}
        </>
      ),
      width: "200px",
    },
    {
      name: "IFSC / Bank",
      selector: (row) => (
        <>
          <div><strong>IFSC</strong>: {row.ifscCode}</div>
          {row.bankName && (
            <div><strong>Bank</strong>: {row.bankName}</div>
          )}
        </>
      ),
      width: "200px",
    },
    {
      name: "Account",
      selector: (row) => (
        <>
          <div>{row.accountNumber}</div>
          <div><strong>UP</strong>: {getUTCToLocalDateFormat(row.updatedAt)}</div>
        </>
      ),
      width: "150px",
    },
    {
      name: "Bene Name",
      selector: (row) => (
        <div>
          <strong>
            {row.isVerified ? (
              <CheckOutlined className="text-120 text-success border p-1" />
            ) : (
              <CloseOutlined className="text-120 text-danger border p-1" />
            )}
          </strong>{" "}
          {row.beneBankName}{" "}
        </div>
      ),
      width: "200px",
    },
    {
      name: "Verified",
      selector: (row) => {
        const isVerifying = verifyingKey === row._id;
        return (
          <button
            onClick={() => handleVerifyClick(row)}
            className={row.isVerified ? "pointer text-success" : "pointer text-danger"}
            disabled={!row.isActive || isVerifying}
            style={{ display: "inline-flex", alignItems: "center", gap: 6 }}
          >
            {isVerifying
              ? "Verifying..."
              : row.isVerified
              ? RE_CHECK
              : GET_NAME}
          </button>
        );
      },
      width: "150px",
    },
    {
      name: "Status",
      selector: (row) =>
        !row.beneficiary_id || row.beneficiary_id.trim() === "" ? (
          <button
            className="pointer text-danger"
            disabled
            style={{
              whiteSpace: "normal",
              wordWrap: "break-word",
              maxWidth: "100px",
            }}
          >
            Bene ID Missing
          </button>
        ) : row.isActive ? (
          <button
            onClick={() => beneStatus(row, false)}
            className="pointer text-success"
          >
            Active
          </button>
        ) : (
          <button
            onClick={() => beneStatus(row, true)}
            className="pointer text-danger"
          >
            Deactive
          </button>
        ),
      width: "100px",
    },
    {
      name: "Amount",
      cell: (row, index) => (
        <input
          type="text"
          name="amount"
          className="form-control"
          onChange={(e) => handleEditRowAmount(e, index)}
          placeholder="Amount"
          onKeyDown={isNumber}
          maxLength={5}
          disabled={!row.isActive}
        />
      ),
      width: "120px",
    },
    {
      name: "Action",
      selector: (row) => (
        <Button
          type="primary"
          onClick={() => sendMoney(row)}
          disabled={row.isActive ? isSendButtonDisable : true}
          size="small"
        >
          Send
        </Button>
      ),
      width: "150px",
      fixed: "right",
    },
  ];

  useEffect(() => {
    setCustomerMobile(props.customerData && props.customerData.customerMobile);
    setCustomerAutoId(props.customerData && props.customerData._id);
    setCustomerName(props.customerData && props.customerData.customerName);
  }, [props.customerData]);

  const handleSyncBeneficiary = () => {
    getDataReports();
  };

  const beneStatus = (data, status) => {
    let params = {};
    params.id = data._id;
    params.status = status;
    postRequest(POST_PAYOUT_UPDATE_STATUS_BENEFICIARY, params, history)
      .then((response) => {
        if (response.success === true) {
          getDataReports();
        }
        toast.success(response.message, { toastId: "success1" });
      })
      .catch(function (error) { });
  };

  const beneBankLimit = (account_Number, detailFor) => {
    let params = {};
    params.accountNumber = account_Number;
    params.detail_for = detailFor;
    postRequest(POST_BENE_BANK_ACCOUNT_LIMIT, params, history)
      .then((response) => {
        if (response.success === true) {
          setBeneAccountLimit(response.beneAccountLimit);
        }
      })
      .catch(function (error) { });
  };

  const updateBeneData = (data) => {
    let params = {};
    params.id = data._id;
    params.beneBankName = data.beneBankName;
    postRequest(POST_PAYOUT_UPDATE_BENEFICIARY_DETAIL, params, history)
      .then((response) => {
        if (response.success === true) {
          getDataReports();
        }
      })
      .catch(function (error) { });
  };

  const getBankList = () => {
    getRequest(GET_DMT_NEW_BANK_LIST, history)
      .then((response) => {
        if (response.success === true) {
          let bankDataRecord = [];
          if (response.data) {
            bankDataRecord = response.data.filter(
              (item) => item.key === "DMT1.0"
            );
          }
          setEKOBankListData(bankDataRecord);
          setBankListData([
            { value: "", label: "-- Select Bank --" },
            ...bankDataRecord.map((item) => ({
              value: item.BankID,
              label: item.BANK_NAME,
            })),
          ]);
        }
      })
      .catch(function (error) { });
  };

  const onChangeBankIfscCode = (value) => {
    if (value) {
      let findBank = getEKOBankListData.filter((item) => item.BankID === value);
      if (findBank.length > 0) {
        setSelectedOption({
          value: findBank[0].BankID,
          label: findBank[0].BANK_NAME,
        });
        if (findBank[0].ifsc) {
          setBeneData({ ...getBeneData, ifscCode: findBank[0].ifsc });
          let obj = {};
          obj.target = { name: "ifscCode", value: findBank[0].ifsc };
          enterIfscCode(obj);
          setIfscEnable(true);
        } else {
          setBeneData({ ...getBeneData, ifscCode: "" });
          setIfscEnable(false);
        }
        setBankId(findBank[0].BankID);
        setBankName(findBank[0].BANK_NAME);
      } else {
        setBankId(null);
      }
    } else {
      setBankId(null);
      setIfscEnable(false);
      setBeneData({ ...getBeneData, ifscCode: "" });
    }
  };

  const enterIfscCode = async (event) => {
    let { name, value } = event.target;
    setBeneData({ ...getBeneData, [name]: value });
    if (isIfscCodeValid(value)) {
      onChangeIfscCode(value);
      setBeneError({ ...getBeneError, ifscCodeVaild: 1 });
    } else {
      setBeneError({ ...getBeneError, ifscCodeVaild: 2 });
    }
  };

  const handleEditRowAmount = (event, index) => {
    let array = { ...getData };
    array.docs[index].amount = event.target.value;
    const value = parseFloat(event.target.value);
    const maxLimit = Math.min(
      props.customerData?.availableLimit || 10000,
      props.eligibleLimit || 10000
    );
    if (value < 500) {
      toast.error("Minimum amount is: 500", { toastId: "error_min" });
      setSendButtonDisable(true);
      event.preventDefault();
      return false;
    } else if (value > maxLimit) {
      toast.error(`Maximum amount is: ${maxLimit}`, { toastId: "error_max" });
      setSendButtonDisable(true);
      event.preventDefault();
      return false;
    } else {
      setSendButtonDisable(value < 1);
      setData(array);
    }
  };

  const handleAmount = (event) => {
    const value = parseFloat(event.target.value);
    const maxLimit = Math.min(
      props.customerData?.availableLimit || 10000,
      props.eligibleLimit || 10000
    );
    if (value > maxLimit) {
      toast.error(`Amount cannot exceed eligible limit of ${maxLimit}`);
      event.preventDefault();
      return;
    }
    setSendMoneyAmount(event.target.value);
  };

  const onChangeAddBeneName = async (event) => {
    let { name, value } = event.target;
    if (isAlphabetOnly(value)) {
      setBeneData({ ...getBeneData, [name]: value });
    } else {
      event.preventDefault();
    }
  };

  const onChangeAddBene = (event) => {
    let { name, value } = event.target;
    setBeneData({ ...getBeneData, [name]: value });
  };

  // ============================================================
  // sendMoney — verify mandatory before transaction
  // ============================================================
  const sendMoney = (row) => {
    if (!row.beneficiary_id?.trim()) {
      toast.error(
        "Beneficiary ID is missing. Please contact SR PAY Support Team"
      );
      return false;
    }
    if (!row.amount) {
      toast.error("Amount is empty");
      return false;
    }
    if (!row.isVerified || !row.beneBankName || row.beneBankName.trim() === "") {
      Modal.confirm({
        title: "Bank Account Not Verified",
        content:
          "You must verify the beneficiary bank account before sending money. Would you like to verify it now?",
        okText: "Verify Now",
        cancelText: "Cancel",
        onOk: () => handleVerifyClick(row),
      });
      return false;
    }

    // Clone the row so we don't mutate the table data
    const enrichedRow = {
      ...row,
      isChannel: isSelectedUser?.isChannel ? isSelectedUser.isChannel : "4",
    };
    setSendMoneyModal(true);
    setIsSelectedUser(enrichedRow);
    beneBankLimit(row.accountNumber, "quickSettlement");
  };

  // ============================================================
  // handleSave — validate relation + pass it in payload
  // ============================================================
  const handleSave = (data) => {
    if (!selectedRelation) {
      toast.error("Please select a relation before continuing.");
      return;
    }
    if (sendMoneyAmount !== data.amount) {
      toast.error("Amount did not matched.");
      return;
    }

    const payload = {
      customerId: saveCustomerAutoId,
      customerName: saveCustomerName,
      beneficiaryId: data._id,
      beneficiaryName: data.beneName,
      accountNumber: data.accountNumber,
      ifsccode: data.ifscCode,
      amount: sendMoneyAmount,
      channel: data.isChannel,
      relation: selectedRelation,   // ← captured from the modal
      apiName: "PAYOUTV2",
      latitude: latitude,
      longitude: longitude,
      detail_for: "quickSettlement",
      txnType: "fund_transfer",
    };
    handleSubmit(payload);
  };

  const handleSubmit = async (data) => {
    setLoading(true);
    await postRequest(`${POST_FUND_TRANSFER_REQUEST}`, data, history)
      .then((response) => {
        if (response.success === true) {
          handleHideModal();
          getDataReports();
          toast.success(response.message);
          const txnId = response.data?.transactionId;
          if (txnId) {
            history.push(`/fundtransferinvoice/${txnId}`);
          } else {
            history.push("/fund-transfer-report");
          }
        } else {
          toast.error(response.message);
        }
        setSendMoneyAmount("");
        setLoading(false);
      })
      .catch(function (error) {
        console.log(error);
        setLoading(false);
        handleHideModal();
        toast.error("Transaction failed");
      });
  };

  const handleInvoice = (data) => {
    setInvoiceDataModal(true);
    setInvoiceData(data);
  };

  const handleInvoiceModal = () => {
    setInvoiceDataModal(false);
  };

  const addBane = () => {
    setBeneData({
      mobile: "",
      name: "",
      ifscCode: "",
      accountNumber: "",
      beneBankName: "",
    });
    setDataField({});
    setSelectedOption(null);
    setIfscEnable(false);
    setBankId(null);
    setBankName("");
    setBeneError({});
    setAddBaneModal(true);
  };

  // ============================================================
  // FormBaneValidate — beneBankName is now OPTIONAL
  // ============================================================
  const FormBaneValidate = () => {
    let formValid = true;
    let formObject = {};
    setBeneError({});
    let array = ["mobile", "name", "ifscCode", "accountNumber"];
    array.forEach((element) => {
      if (!getBeneData[element] || getBeneData[element] === "") {
        formObject[element] = true;
        formValid = false;
      }
    });
    // NOTE: beneBankName removed from required fields — verification
    // is now optional on Add, but enforced before Send Money.
    setBeneError(formObject);
    return formValid;
  };

  const addBaneSave = () => {
    if (FormBaneValidate() === true) {
      const payload = {
        customerMobile: saveCustomerMobile,
        recipientMobile: getBeneData.mobile,
        accountNumber: getBeneData.accountNumber,
        ifscCode: getBeneData.ifscCode,
        bankId: bankId,
        bankName: bankName,
        recipientName: getBeneData.name,
        beneBankName: getBeneData.beneBankName,
        apiName: "PAYOUTV2",
        latitude: latitude,
        longitude: longitude,
        isRemittanceBene: false,
      };
      setLoading(true);
      postRequest(`${POST_FUND_TRANSFER_ADD_BENEFICIARY}`, payload, history)
        .then((response) => {
          if (response.success === true) {
            toast.success(response.message);
            getDataReports();
            setBeneData({});
            setAddBaneModal(false);
          } else {
            toast.error(response.message);
          }
          setLoading(false);
        })
        .catch(function (error) {
          setLoading(false);
        });
    }
  };

  const handleHideModal = () => {
    setSendMoneyModal(false);
    setAddBaneModal(false);
    setSendMoneyAmount("");
    setSelectedRelation("Friend");
  };

  const objectToQueryString = (obj) => {
    var str = [];
    for (var p in obj)
      if (obj.hasOwnProperty(p)) {
        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
      }
    return str.join("&");
  };

  const params = { page: page, limit: isLimit };

  const getDataReports = (data) => {
    if (data) {
      setLimit(data);
      params.limit = data;
    }
    if (searchText) {
      params.search = searchText;
    }
    if (props.customerData && props.customerData.customerMobile) {
      params.customerMobile = props.customerData.customerMobile;
      setCustomerMobile(params.customerMobile);
    }
    const queryString = objectToQueryString(params);
    getRequest(`${POST_PAYOUT_GET_BENEFICIARY}?${queryString}`, history)
      .then((response) => {
        if (response.success === true) {
          setData(response.data);
        } else {
          setPage(1);
        }
      })
      .catch(function (error) { });
  };

  const handlePageChange = (page) => {
    setPage(page);
  };

  // ============================================================
  // Bank verification — Row (list) flow (shared hook)
  // ============================================================
  const handleVerifyClick = (row) => {
    if (row.isVerified) {
      // Re-Verify → direct API call with recheck=true, no picker.
      getName(row, true);
      return;
    }
    // Get Name → let user pick Bank 1 or Bank 2.
    showBankVerifyPicker({
      title: "Verify Bank Account",
      subtitle: `${row.beneName || row.accountNumber} — choose verification method`,
      onBank1: () => getName(row, false),
      onBank2: () => getName(row, true),
    });
  };

  const getName = (data, recheck) => {
    if (!data?.accountNumber || !data?.ifscCode) {
      toast.error("Account number and IFSC are required.");
      return;
    }
    verify({
      key: data._id,
      accountNumber: data.accountNumber,
      ifscCode: data.ifscCode,
      recheck: !!recheck,
      endpoint: GET_CUSTOMER_BANK_NAME_FROM_ACCOUNT_NUMBER,
      latitude,
      longitude,
      history,
      onSuccess: (result) => {
        // Show Aadhaar verification detail modal
        setAadharVerifyDetail(result.dataNode || result.raw);
        setAadharVerifyModal(true);
        // Persist name on the beneficiary record
        updateBeneData({ ...data, beneBankName: result.nameAtBank });
      },
    });
  };

  // ============================================================
  // Bank verification — Add Beneficiary flow (shared hook)
  // ============================================================
  const getBankNameFromAccountNumber = () => {
    if (!getBeneData.accountNumber || !getBeneData.ifscCode) {
      toast.error("Please enter account number and IFSC first.");
      setBeneData({ ...getBeneData, name: "" });
      return;
    }
    showBankVerifyPicker({
      title: "Verify Bank Account",
      subtitle: "Choose a verification method",
      onBank1: () => runAddVerify(false),
      onBank2: () => runAddVerify(true),
    });
  };

  const runAddVerify = (recheck) => {
    verify({
      key: "add",
      accountNumber: getBeneData.accountNumber,
      ifscCode: getBeneData.ifscCode,
      recheck: !!recheck,
      endpoint: GET_CUSTOMER_BANK_NAME_FROM_ACCOUNT_NUMBER,
      latitude,
      longitude,
      history,
      onSuccess: (result) => {
        setBeneData((prev) => ({ ...prev, beneBankName: result.nameAtBank }));
      },
    });
  };

  const onChangeIfscCode = (val = null) => {
    let value;
    if (val) {
      value = val;
    } else {
      value = getBeneData && getBeneData.ifscCode;
    }
    if (isIfscCodeValid(value)) {
      const payload = { ifsccode: value };
      postRequest(`${IFSC_CODE_VERIFY}`, payload, history)
        .then((response) => {
          if (response.success === true) {
            let record = response.data.data;
            let Object = {
              ifscCode: record.ifsc,
              address: record.address,
              bankName: record.bank,
              branchAddress: record.branch,
              city: record.city,
              state: record.state,
            };
            setDataField(Object);
          }
        })
        .catch(function (error) { });
    } else {
      if (value && value.length === 11) {
        toast.error("Please enter valid ifsccode");
        setDataField({
          address: "",
          bankName: "",
          branchAddress: "",
          city: "",
          state: "",
        });
      }
    }
  };

  const handleSearch = (e) => {
    setSearchText(e.target.value);
  };

  const onChangeChannel = ({ target: { value } }) => {
    let isSelectedUserValue = { ...isSelectedUser };
    isSelectedUserValue.isChannel = value;
    setIsSelectedUser(isSelectedUserValue);
  };

  const handleImport = () => {
    setImportModal(true);
  };

  const handleImportCancel = () => {
    setImportModal(false);
  };

  useEffect(() => {
    if (timer) {
      clearTimeout(timer);
      setTimer(null);
    }
    setTimer(
      setTimeout(() => {
        getDataReports();
      }, 100)
    );
  }, [searchText]);

  useEffect(() => {
    if (props.customerData && props.customerData.customerMobile) {
      getDataReports();
    }
  }, [page, props.handleSearch]);

  useEffect(() => {
    getBankList();
    const userData = getUser();
    const shopsLat = userData?.data?.shopsLat;
    const shopsLong = userData?.data?.shopsLong;
    if (shopsLat !== undefined && shopsLat !== null && Number(shopsLat) !== 0) {
      setLatitude(Number(shopsLat));
      setLongitude(Number(shopsLong));
    } else {
      navigator.geolocation.getCurrentPosition((data) => {
        setLatitude(data.coords.latitude);
        setLongitude(data.coords.longitude);
      });
    }
  }, [props.customerData]);

  if (isLoading) {
    return (
      <div className="content text-center" style={{ margin: "250px 0" }}>
        <PropagateLoader color="#5851D2" loading={isLoading} size={25} />
      </div>
    );
  }

  return (
    <div>
      <div className="pt-2 pb-5">
        <div className="col-md-12">
          <div className="row pb-3">
            <div className="col-md-6 date-search">
              <div className="row">
                <div className="input-group">
                  <input
                    className="form-control py-2 border-right-0 border"
                    type="search"
                    value={searchText}
                    placeholder="Search Account Number..."
                    maxLength={20}
                    onChange={(e) => handleSearch(e)}
                  />
                  <span className="input-group-append">
                    <button
                      className="btn btn-outline-secondary border-left-0 border"
                      type="button"
                      onClick={() => getDataReports()}
                    >
                      <i className="fa fa-search" />
                    </button>
                  </span>
                </div>
              </div>
            </div>
            <div className="col-md-6 p-0">
              <div className="float-sm-right">
                <button
                  type="button"
                  className="btn btn-primary mr-2"
                  onClick={() => handleImport()}
                >
                  <i className="fa fa-users"></i> Import
                </button>
                <button
                  type="button"
                  className="btn btn-primary mr-2"
                  onClick={() => handleSyncBeneficiary()}
                >
                  <i className="fa fa-users"></i> View Beneficiary
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={addBane}
                >
                  <i className="fa fa-user"></i> Add Beneficiary
                </button>
              </div>
            </div>
          </div>

          <div className="box-body">
            <DataTable
              columns={columns}
              data={getData.docs || []}
              highlightOnHover
              pagination
              paginationServer
              paginationTotalRows={getData.totalDocs || 0}
              onChangeRowsPerPage={getDataReports}
              onChangePage={handlePageChange}
            />
          </div>
        </div>
      </div>

      <ToastContainer
        position="top-center"
        autoClose={5000}
        limit={2}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />

      {/* ============================================================
          Add Beneficiary Modal — Verify is now OPTIONAL
          ============================================================ */}
      {isAddBaneModal && (
        <Modal
          title={"Add Beneficiary"}
          width={400}
          visible={isAddBaneModal}
          onOk={addBaneSave}
          onCancel={handleHideModal}
          okText={"Submit"}
          cancelText={"Cancel"}
          destroyOnClose
        >
          <div className="row">
            <div className="form-group col-lg-12 col-md-12">
              <label>Account Holder Mobile</label>
              <div className="input-group">
                <div className="custom-file">
                  <input
                    type="text"
                    className="form-control"
                    name="mobile"
                    placeholder="Mobile Number"
                    onChange={(e) => onChangeAddBene(e)}
                    autoComplete="off"
                    value={getBeneData.mobile || ""}
                    maxLength={10}
                    onKeyDown={isNumber}
                  />
                </div>
              </div>
              {getBeneError && getBeneError.mobile && (
                <span className="error text-danger">The field is required</span>
              )}
            </div>

            <div className="form-group col-lg-12 col-md-12">
              <label>Account Holder Name</label>
              <div className="input-group">
                <div className="custom-file">
                  <input
                    type="text"
                    className="form-control"
                    name="name"
                    placeholder="Account Holder Name"
                    onChange={(e) => onChangeAddBeneName(e)}
                    autoComplete="off"
                    value={getBeneData.name || ""}
                    maxLength={20}
                  />
                </div>
              </div>
              {getBeneError && getBeneError.name && (
                <span className="error text-danger">The field is required</span>
              )}
            </div>

            <div className="form-group col-lg-12 col-md-12">
              <label>Bank Name</label>
              <div className="input-group">
                <div className="custom-file">
                  <Select
                    options={getBankListData}
                    className={`normal-light w-100`}
                    value={selectedOption}
                    classNamePrefix="select"
                    placeholder="Select Bank"
                    name="mode"
                    isClearable
                    onChange={(e) => onChangeBankIfscCode(e && e.value)}
                  />
                </div>
              </div>
            </div>

            <div className="form-group col-lg-12 col-md-12">
              <label>Global IFSC Code</label>
              <div className="input-group">
                <div className="custom-file">
                  <input
                    type="text"
                    className="form-control"
                    name="ifscCode"
                    placeholder="Enter IFSC Code"
                    onChange={(e) => enterIfscCode(e)}
                    autoComplete="off"
                    readOnly={isIfscEnable}
                    value={getBeneData.ifscCode || ""}
                    maxLength={11}
                  />
                  <div
                    className="inputgrouptext cursor-pointer text-success"
                    onClick={() =>
                      onChangeIfscCode(getBeneData && getBeneData.ifscCode)
                    }
                  >
                    Verify Branch
                  </div>
                </div>
              </div>
              {getBeneError && getBeneError.ifscCode && (
                <span className="error text-danger">The field is required</span>
              )}
            </div>

            {getDataField &&
              getDataField.address &&
              getDataField.bankName &&
              getDataField.branchAddress &&
              getDataField.city &&
              getDataField.state && (
                <div className="form-group col-lg-12 col-md-12">
                  <div className="custom-file">
                    <ul>
                      <li>Address: <strong>{getDataField.address}</strong></li>
                      <li>Bank Name: <strong>{getDataField.bankName}</strong></li>
                      <li>Branch Address: <strong>{getDataField.branchAddress}</strong></li>
                      <li>City: <strong>{getDataField.city}</strong></li>
                      <li>State: <strong>{getDataField.state}</strong></li>
                    </ul>
                  </div>
                </div>
              )}

            <div className="form-group col-lg-12 col-md-12">
              <label>Account Number</label>
              <div className="input-group">
                <div className="custom-file">
                  <input
                    type="text"
                    className="form-control"
                    name="accountNumber"
                    placeholder="Account Number"
                    onChange={(e) => onChangeAddBene(e)}
                    autoComplete="off"
                    value={getBeneData.accountNumber || ""}
                    maxLength={18}
                  />
                  <button
                    className="inputgrouptext cursor-pointer text-success"
                    onClick={getBankNameFromAccountNumber}
                    disabled={verifyingKey === "add"}
                  >
                    {verifyingKey === "add" ? "Verifying..." : GET_NAME}
                  </button>
                </div>
              </div>
              {getBeneError && getBeneError.accountNumber && (
                <span className="error text-danger">The field is required</span>
              )}
            </div>

            {getBeneData.beneBankName && (
              <div className="form-group col-lg-12 col-md-12">
                <label>Bene Bank Name</label>
                <div className="input-group">
                  <div className="custom-file">
                    <input
                      type="text"
                      className="form-control"
                      readOnly
                      autoComplete="off"
                      value={getBeneData.beneBankName || ""}
                      maxLength={20}
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
        </Modal>
      )}

      {/* Send Money Modal — relation captured + sent in payload */}
      {isSendMoneyModal && (
        <Modal
          title={"Money Transfer Verification"}
          width={600}
          visible={isSendMoneyModal}
          onOk={() => handleSave(isSelectedUser)}
          onCancel={handleHideModal}
          okText={"Continue"}
          cancelText={"Cancel"}
        >
          <div className="row">
            <div className="col-md-12 form-group d-flex">
              <div className="col-md-8">
                <div>Bank Name : <strong>{isSelectedUser.bankName}</strong></div>
                <div>IFSC Code : <strong>{isSelectedUser.ifscCode}</strong></div>
                <div>Account Number : <strong>{isSelectedUser.accountNumber}</strong></div>
                <div>Customer Name : <strong>{isSelectedUser.beneName}</strong></div>
                <div>Account Limit : <strong>{beneAccountLimit}</strong></div>
                <div>
                  Customer Available Limit :{" "}
                  <strong>{props.customerData?.availableLimit || "N/A"}</strong>
                </div>
              </div>
            </div>

            <div className="col-md-12 form-group">
              <label htmlFor="relation">Select Relation: <span className="text-danger">*</span></label>
              <br />
              <select
                id="relation"
                value={selectedRelation}
                onChange={(e) => setSelectedRelation(e.target.value)}
                style={{ padding: "8px", marginTop: "5px", width: "250px" }}
              >
                <option value="">-- Select Relation --</option>
                {relations.map((relation, index) => (
                  <option key={index} value={relation}>{relation}</option>
                ))}
              </select>
            </div>

            <div className="col-md-12 form-group">
              <label>
                <span style={{ color: "#D97706", fontWeight: "bold" }}>
                  Please Note:
                </span>{" "}
                Your fund settlement request will take up to 30 minutes to process. Please check your transaction status after some time.
                <span style={{ fontWeight: "bold" }}>
                  Please confirm to continue.
                </span>
              </label>
            </div>

            <div className="col-md-12 form-group">
              <label>Confirm Amount: </label>
              <input
                type="text"
                name="amount"
                className="form-group form-control"
                value={sendMoneyAmount || ""}
                onChange={(e) => handleAmount(e)}
                onKeyDown={isNumber}
                maxLength={5}
                placeholder="Confirm Amount"
              />
            </div>
          </div>
        </Modal>
      )}

      {/* Invoice Modal */}
      {invoiceDataModal && (
        <Modal
          visible={invoiceDataModal}
          width={800}
          footer={false}
          onCancel={handleInvoiceModal}
          closable={false}
        >
          <PayoutInvoice
            transactionId={invoiceData && invoiceData.transactionId}
          />
        </Modal>
      )}

      {/* Aadhaar Verify Modal */}
      {aadharVerifyModal && (
        <Modal
          title={"Aadhaar Verification Detail"}
          width={600}
          visible={aadharVerifyModal}
          onOk={() => {
            setAadharVerifyDetail({});
            setAadharVerifyModal(false);
          }}
          onCancel={() => {
            setAadharVerifyDetail({});
            setAadharVerifyModal(false);
          }}
          okText={"Ok"}
          cancelText={"Cancel"}
        >
          <div className="row">
            <div className="col-md-12 form-group">
              <div>
                Name :{" "}
                <strong>
                  {aadharVerifyDetail &&
                    (aadharVerifyDetail.data?.nameAtBank ||
                      aadharVerifyDetail.nameAtBank)}
                </strong>
              </div>
              <div>
                {aadharVerifyDetail &&
                  aadharVerifyDetail.accountStatus === "VALID" ? (
                  <p className="text-bold text-success">
                    {aadharVerifyDetail.message}
                  </p>
                ) : (
                  <p className="text-bold text-danger">
                    {aadharVerifyDetail.message}
                  </p>
                )}
              </div>
            </div>
          </div>
        </Modal>
      )}

      {/* Import Modal */}
      {importModal && (
        <Modal
          visible={importModal}
          width={1200}
          footer={false}
          onCancel={handleImportCancel}
          closable={true}
          maskClosable={false}
          keyboard={false}
          destroyOnClose={true}
        >
          <ImportBaneficiary
            mode={"DMT1.0"}
            customerMobile={saveCustomerMobile}
            addBaneficiary={importBaneficiarySave}
            bankList={getBankListData}
            bankData={getEKOBankListData}
          />
        </Modal>
      )}
    </div>
  );
}

export default Beneficiarylist;